module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-4.45e258c1.webp";